import React from "react";
import HelperText from "../FormElements/HelperText";
import "select2";
import FieldErrors from "../ErrorComponents/FieldErrors/FieldErrors";

export default class OrganizationSelectbox extends React.Component {
  constructor(props) {
    super(props);

    this.selectRef = React.createRef();
  }

  componentDidMount() {
    var self = this;

    $(this.selectRef.current).select2({
      ajax: {
        url: "/api/v1/organizations/search",
        dataType: "json",
        data: function (params) {
          return {
            name: $(self.selectRef.current)
              .data("select2")
              .dropdown.$search.val(),
            page: isNaN(params.page) ? 1 : params.page - 1,
          };
        },
        delay: 250,
        processResults: function (response, params) {
          const results = response.data.map((element) => {
            return { id: element.id, text: element.name };
          });
          return {
            results: results,
            page: isNaN(params.page) ? 1 : params.page,
            pagination: {
              more:
                response.meta.page.pageNumber < response.meta.page.totalPages,
            },
          };
        },
      },
      allowClear: true,
      createTag: function (tag) {
        return {
          id: tag.term,
          text: tag.term,
          isNew: true,
        };
      },
      language: {
        searching: function () {
          return I18n.t("loading");
        },
      },
      placeholder: self.props.placeholder,
      tags: self.props.permissionsHelper.hasCreateOrganizationPermissions()
        ? true
        : false,
    });

    $(this.selectRef.current).on("select2:close", function (e) {
      if (typeof self.props.onChange === "function") {
        self.props.onChange($(self.selectRef.current).select2("data")[0] || {});
      }
    });
  }

  render() {
    // console.log('Select2 - Props', this.props, "'Select2- State", this.state);
    const {
      name,
      style = {},
      fieldErrors = [],
      helperText = null,
      onChange = () => {},
    } = this.props;

    return (
      <div className="row">
        <div className="col-sm-12" style={{ position: "relative" }}>
          <div style={style}>
            <select ref={this.selectRef} name={name} onChange={onChange} />
          </div>
          {fieldErrors && fieldErrors.hasOwnProperty(name) ? (
            <FieldErrors fieldName={name} fieldErrors={fieldErrors} />
          ) : helperText ? (
            <HelperText>{helperText}</HelperText>
          ) : null}
        </div>
      </div>
    );
  }
}
